<template>
  <el-row>
    <div class="tag">
       <el-radio-group v-model="deviceName" size="small" @change="handleChange">
        <el-radio-button value="ele1" label="制造业" />
        <el-radio-button value="ele2" label="服务业" />
        <el-radio-button value="ele3" label="信息传输、软件和信息技术服务业" />
      </el-radio-group>
    </div>
    <div id="cityEchart" :style="{ width: '100%', height: '225px' }"></div>
  </el-row>
</template>

<script>
import {onMounted, onUnmounted } from 'vue'
import * as echarts from "echarts";
export default {
  name: "cityEchart",
  data(){
    return {
      deviceName: 'ele1',
    }
  },
  setup() {
    /// 声明定义一下echart
    let echart = echarts;
    onMounted(() => {
      cityEchart([19580,19428,8989,7962,7795,6535,6056,5594,3955,3525],['江苏','广东','浙江','北京','上海','安徽','黑龙江','四川','山东','湖北']);
    });
    onUnmounted(() => {
      echart.dispose();
    });
    function handleChange(val) {
        if(val === 'ele1') {
          cityEchart([19580,19428,8989,7962,7795,6535,6056,5594,3955,3525],['江苏','广东','北京','浙江','上海','安徽','黑龙江','四川','湖北','山东']);
        } else if(val === 'ele2') {
          cityEchart([5024,3628,1828,1441,1328,957,830,733,609,544],['广东','北京','上海','江苏','浙江','黑龙江','四川','山东','安徽','湖北']);
        } else if(val === 'ele3'){
         cityEchart([4242,3257,1076,945,943,605,588,508,385,283],['广东','北京','上海','江苏','浙江','山东','四川','黑龙江','湖北','陕西']);
        }
    }
    function cityEchart(xData,yData) {
      let chart = echart.init(document.getElementById("cityEchart"));
      // 把配置和数据放这里
      chart.setOption({
        tooltip: {
        trigger: 'axis',
            axisPointer: {
            // Use axis to trigger tooltip
            type: 'shadow' // 'shadow' as default; can also be 'line' or 'shadow'
         }
        },
        axisLabel: {
            color: '#fff',
            fontSize: '16px',
        },
        legend: {
            textStyle: {
               color: '#fff',      // 图例文字颜色
               fontSize: '14px'
            },
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '1%',
            top: '2%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            show: false,
            splitLine: {
            show: false,
          }
        },
        yAxis: {
            type: 'category',
            data: yData,
            inverse: true,
            axisLabel: {
            color: '#fff',
            fontSize: '14px',
            },
        },
        series: [
            {
            // name: '失效',
            type: 'bar',
            stack: 'total',
            label: {
                show: false
            },
            color: '#57c6c0',
            emphasis: {
                focus: 'series'
            },
            data: xData
            },
        ]
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    return { cityEchart,handleChange};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .tag{
  margin: 15px auto;
  margin-bottom: 20px;
 }
 .tag span{
  padding: 6px;
  cursor: pointer;
 }
 .tag span.active{
  color: #409eff;
  font-weight: 500;
 }
</style>
